import shouldShowUnstackedReadingPane from 'owa-mail-organization-settings/lib/utils/shouldShowUnstackedReadingPane';

import {
    flaggedMailListItemColor,
    selectedMailListItemColor,
} from 'owa-mail-listitem-styles/lib/scss/MailListItemBackgroundColors.scss';

export default function getBackgroundColorClass(
    isSelected: boolean,
    isFlagged: boolean,
    isChecked: boolean,
    supportsFlagging: boolean,
    isRowExpanded: boolean,
    isPendingSelection?: boolean
): string {
    if (isSelected || isChecked || isPendingSelection) {
        // when row is expanded, the following styles apply to the top level item.
        const showOnlySubject = shouldShowUnstackedReadingPane() && isRowExpanded;
        if (showOnlySubject && supportsFlagging && isFlagged) {
            return flaggedMailListItemColor;
        }
        return selectedMailListItemColor;
    } else if (supportsFlagging && isFlagged) {
        return flaggedMailListItemColor;
    } else {
        // Base color class is applied directly in component.
        return '';
    }
}
